import createIcon from '../../createIcon';

/**
 * @component @name BackupTable
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAgNlYyMEg2VjIySDIwQzIxLjEgMjIgMjIgMjEuMSAyMiAyMFY2SDIwWiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTE2IDJINEMyLjkgMiAyIDIuOSAyIDRWMTZDMiAxNy4xIDIuOSAxOCA0IDE4SDE2QzE3LjEgMTggMTggMTcuMSAxOCAxNlY0QzE4IDIuOSAxNy4xIDIgMTYgMlpNOSAxNkg0VjExSDlWMTZaTTE2IDE2SDExVjExSDE2VjE2Wk0xNiA5SDRWNEgxNlY5WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const BackupTable = createIcon('BackupTable', [
  ['path', { d: 'M20 6V20H6V22H20C21.1 22 22 21.1 22 20V6H20Z', key: 'j1rp7e' }],
  [
    'path',
    {
      d: 'M16 2H4C2.9 2 2 2.9 2 4V16C2 17.1 2.9 18 4 18H16C17.1 18 18 17.1 18 16V4C18 2.9 17.1 2 16 2ZM9 16H4V11H9V16ZM16 16H11V11H16V16ZM16 9H4V4H16V9Z',
      key: '13hwzu',
    },
  ],
]);

export default BackupTable;
